export const newsswitchActions = {
    showNews,
}

function showNews(mode) {
    return dispatch => {
        dispatch({ type: mode });
    }
}
